export const GLASS_HEIGHT_CORRECTION = 8
export const GLASS_WIDTH_CORRECTION = 8
export const GLASS_HEIGHT_CORRECTION_WINDOW = 142
export const GLASS_WIDTH_CORRECTION_WINDOW = 132
export const WINDOW_HEIGHT_CORRECTION = 4
export const WINDOW_WIDTH_CORRECTION = 5


// WEBPACK FOOTER //
// ./src/data/corrections.js